/**
 * @author caijianjia
 * @date 2020/3/23 8:58 下午
 */
import request from '../config/network/requestUcenterApiService'

/**
 * 根据校区id获取腾讯云上传密钥
 */
export function getTXToken ({ cloud = 'tencent', clientsId = 0, ...params }) {
  return request({
    url: 'api/resources/token',
    method: 'post',
    data: {
      cloud,
      clients_id: clientsId,
      ...params
    }
  })
}
/**
 * 上传回调给腾讯云
 */
export function setCallBackTencent ({ appid, secretId, region, bucket, key, ...params }) {
  return request({
    url: 'api/resources/callback-tencent',
    method: 'post',
    data: { appid, secret_id: secretId, region, bucket, key, ...params }
  })
}
